import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalHeaderComponent } from './modal-header/modal-header.component';
import { ModalFooterComponent } from './modal-footer/modal-footer.component';
import { StandardModalWindowComponent } from './modal-window/standard/standard-modal-window.component';
import { ModalPresenter } from './presenter/modal-presenter.service';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [ModalHeaderComponent, ModalFooterComponent, StandardModalWindowComponent],
  exports: [ModalHeaderComponent, ModalFooterComponent, StandardModalWindowComponent],
  providers: [ModalPresenter],
  imports: [CommonModule, NgbModalModule],
})
export class ModalModule {}
